/**
 * @generated SignedSource<<be9a23b6f9b14c34c9788ae1cfcfa06f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTableSection_company$data = {
  readonly newXeroEnabled: boolean | null;
  readonly quickbooksEnabled: boolean | null;
  readonly economicEnabled: boolean | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTable_company" | "ExportInvoiceButton_company" | "InvoiceFilterButton_company">;
  readonly " $fragmentType": "ProjectInvoicingTableSection_company";
};
export type ProjectInvoicingTableSection_company$key = {
  readonly " $data"?: ProjectInvoicingTableSection_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTableSection_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTableSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newXeroEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quickbooksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "economicEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectInvoicingTable_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExportInvoiceButton_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceFilterButton_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "0870e7f14fe6062ac836427bea236dbd";

export default node;
